<template>
	<div class="header-wrapper">
		<transition name="fade">
			<keep-alive>
				<router-view name="gameHeader" />
			</keep-alive>
		</transition>
	</div>
</template>

<script>
export default {
	name: 'GameHeader',
};
</script>

<style lang="scss" scoped>
</style>
